<template>
    <div>
        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <div>
                    <div class="file-upload-form">
                        <!-- <label class="required">Добавьте изображение:</label> -->
                    </div>

                    <div class="vx-row">
                        <div class="vx-col">
                            <div v-if="uploaded && !loaded && uploaded.data1 && uploaded.data1.length > 0" class="mb-4 mr-2">
                                <label>{{uploaded.width1}}x{{uploaded.height1}}</label>
                                <img class="image-preview" :src="uploaded.data1" width="246" />
                            </div>
                            <div v-if="uploaded && !loaded && uploaded.data2 && uploaded.data2.length > 0" class="mb-4 mr-2">
                                <label>{{uploaded.width2}}x{{uploaded.height2}}</label>
                                <img class="image-preview" :src="uploaded.data2" width="150" />
                            </div>

                            <div v-if="image && loaded && image.data1.length > 0" class="mb-4 mr-2">
                                <label>{{image.sourceWidth1}}x{{image.sourceHeight1}}</label>
                                <img class="image-preview" :src="image.data1" width="246" />
                            </div>
                            <div v-if="image && loaded && image.data2.length > 0" class="mb-4 mr-2">
                                <label>{{image.sourceWidth2}}x{{image.sourceHeight2}}</label>
                                <img class="image-preview" :src="image.data2" width="150" />
                            </div>


                        </div>
                    </div>

                    <vs-button class="mt-5 mb-5" color="warning" @click="openModal()" type="filled"> Загрузить </vs-button>
                </div>
            </div>
        </div>

        <sweet-modal blocking ref="imagesModal" title="Добавление изображений" width="50%">
            <div>
                <label :class="{ 'text-danger': image.wrongSize1 }">{{image.sourceWidth1}}x{{image.sourceHeight1}}</label>
                <input type="file" :ref="'inputFile' + 1" class="hidden" @change="onImageChanged(1, $event)" accept="image/*" />
                <vs-button class="mt-5 ml-2" color="warning" @click="addImage(1)" type="filled" size="small"> Загрузить </vs-button>
                <span class="ml-2">{{image.name1}}</span>
            </div>
            <div>
                <label :class="{ 'text-danger': image.wrongSize2 }">{{image.sourceWidth2}}x{{image.sourceHeight2}}</label>
                <input type="file" :ref="'inputFile' + 2" class="hidden" @change="onImageChanged(2, $event)" accept="image/*" />
                <vs-button class="mt-5 ml-2" color="warning" @click="addImage(2)" type="filled" size="small"> Загрузить </vs-button>
                <span class="ml-2">{{image.name2}}</span>
            </div>
            <div>
                <vs-button class="modalButton ml-5" color="warning" @click="closeModal()" type="filled"> Отмена </vs-button>
                <vs-button class="modalButton ml-5" color="primary" @click="selectImages()" type="filled"> ОК </vs-button>
            </div>
        </sweet-modal>
    </div>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

export default {
    props: {
        uploaded: {},
        campaignId: undefined
    },
    data() {
        return {
            image: {
                name1: '',
                name2: '',
                type: 'image/jpeg',
                imageTypeId: 1,
                data1: '',
                width1: 0,
                height1: 0,
                data2: '',
                width2: 0,
                height2: 0,
                sourceWidth1: 492,
                sourceHeight1: 328,
                sourceWidth2: 300,
                sourceHeight2: 300,
                wrongSize1: false,
                wrongSize2: false,
                checkProportions: true
            },
            loaded: false
        };
    },
    components: {
        SweetModal,
        SweetModalTab
    },

    methods: {
        openModal() {
            this.$refs.imagesModal.open();
        },
        closeModal() {
            this.$refs.imagesModal.close();
        },
        addImage(index) {
            const inputFile = this.$refs['inputFile' + index];
            inputFile.click();
        },
        clearImage(index) {
            const inputFile = this.$refs['inputFile' + index];
            inputFile.value = '';
        },
        async onImageChanged(index, event) {
            var input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                const file = input.files[0];
                if (file.type.indexOf('image/') === -1) {
                    return;
                }

                var compareResult = await this.compareImage(file);
                if (compareResult.isSimilar) {
                    this.clearImage(index);
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Есть похожие картинки, выберите другую.',
                        color: 'warning'
                    });
                }

                if (compareResult.hasErrors) {
                    this.clearImage(index);
                    return this.$vs.notify({
                        title: 'Внимание!',
                        text: 'Ошибка при сравненни картинок!',
                        color: 'danger'
                    });
                }

                this.image['name' + index] = file.name;

                const self = this;
                reader.onload = (e) => {
                    const imageSrc = e.target.result;

                    var imageObj = new Image();
                    imageObj.src = imageSrc;
                    imageObj.onload = function() {
                        debugger
                        self.image['width' + index] = this.width;
                        self.image['height' + index] = this.height;
                        self.image['data' + index] = imageSrc;
                    };
                };
                reader.readAsDataURL(file);
            }
        },
        async compareImage(image) {
            let formData = new FormData();
            formData.append('file', image);

            var result = await this.axios
                .post(`image-compare/targets?campaignId=${this.campaignId}`, formData, {})
                .then((response) => {
                    return { 
                        isSimilar : response.data.isSimilar, 
                        hasErrors: false 
                    };
                })
                .catch((err) => {
                    return { 
                        isSimilar : false, 
                        hasErrors: true
                    };
                });

            return result;
        },
        validateImages() {
            debugger
            if (!this.image.width1 && !this.image.width2) {
                this.$vs.notify({
                    title: "Ошибка!",
                    text: "Необходимо загрузить хотя бы одно изображение.",
                    color: "danger",
                });
                return false;
            }

            this.image.wrongSize1 = (this.image.width1 && this.image.width1 !== this.image.sourceWidth1) || (this.image.height1 && this.image.height1 !== this.image.sourceHeight1);
            this.image.wrongSize2 = (this.image.width2 && this.image.width2 !== this.image.sourceWidth2) || (this.image.height2 && this.image.height2 !== this.image.sourceHeight2);

            const hasWrongSize = this.image.wrongSize1 || this.image.wrongSize2;
            if (hasWrongSize) {
                this.$vs.notify({
                    title: "Ошибка!",
                    text: "Некорректный размер изображения.",
                    color: "danger",
                });
                return false;
            }

            return true;
        },
        selectImages() {
            const self = this;
            setTimeout(function() {
                if (!self.validateImages()) {
                    return;
                }

                self.loaded = true;

                self.closeModal();

                self.$emit("selectImages", self.image);
            }, 1000);
        },

        reset() {
            this.image.id = 0;
            this.image.name = '0f1afea9-5bd9-4e21-87ee-4af98cc4d949.jpg';
            this.image.type = 'image/jpeg';
            this.image.width1 = 492;
            this.image.height1 = 328;
            this.image.width2 = 300;
            this.image.height2 = 300;
            this.image.data1 = '';
            this.image.data2 = '';
        }
    },
    watch: {},
    computed: {
    },
    mounted() {
    }
};
</script>

<style lang="scss">
</style>
